import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import i18n from './i18n'
import constants from '@/constants'

Vue.use(Vuetify, {
  theme: constants.colors.theme,
  options: {
    customProperties: true
  },
  iconfont: 'md',
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  }
})
